/**
 * Find the first id in an object by a predicate of the values in the object
 */
export default function objectFindKey<T>(obj: { [key: string]: T }, pred: (v: T) => boolean): string | undefined {
  if (!obj) {
    return undefined;
  }

  for (const key in obj) {
    if (!pred(obj[key])) {
      continue;
    }
    return key;
  }

  return undefined;
}
